<div class="py-3 pr-2">
	<div class="mailbox-grid">
		<div class="flex flex-column gap-2">
			@if (store.loadingMailboxes()) {
				@for (i of [0,1,2,3,5]; track i) {
					<app-skeleton-card-mailbox />
				}
			} @else {
				<div class="flex flex-column gap-2">
					@for(m of mailboxes(); track m.id) {
						@let isCurrentMailbox = currentMailbox()?.mailbox_id === m.id;
						@let isSelectedMailbox = store.loadedMailbox()?.id === m.id;

						<button type="button"
								[class]="isSelectedMailbox ? 'bg-green-100 border-green-200' : 'surface-border'"
								class="p-2 border-round-lg border-1 cursor-pointer surface-50"
								(click)="selectMailbox(m)">
							<div class="flex gap-2 justify-content-between align-items-center">
								@if (isCurrentMailbox) {
									<i class="pi pi-check-circle"></i>
								}
								<div class="flex flex-column gap-1 flex-1">
									<div class="font-bold">{{ m.mailbox_name }}</div>
									<div class="text-sm text-color-secondary">
										{{ m.mailbox_address }}
									</div>
								</div>
							</div>
						</button>
					}

					<button type="button"
							class="p-2 border-round-lg border-1 cursor-pointer border-dashed surface-50 text-color-secondary hover:text-primary hover:border-primary"
							(click)="facade.startCreateMailbox()">
						<div class="flex gap-2 justify-content-center text-sm">
							<i class="pi pi-plus"></i>
							<span>Aggiungi Mailbox</span>
						</div>
					</button>
				</div>
			}
		</div>

		<div>
			@if (store.loading()) {
				<app-spinner />
			} @else {

				@switch (store.view()) {
					@case ('EMPTY') {
						<div class="p-3 text-color-secondary">
							Seleziona una mailbox o creane una nuova
						</div>
					}

					@case ('CREATE_MAILBOX') {
						<app-mailbox-form
							[form]="mailboxForm"
							[showSubmit]="true"
							(saveRequested)="saveMailbox()" />
					}

					@case ('CONFIG_TABS') {
						<p-tabs>
							<p-tablist>
								<p-tab value="0">Mailbox</p-tab>
								<p-tab value="1">Inbound</p-tab>
								<p-tab value="2">Outbound</p-tab>
							</p-tablist>

							<p-tabpanels>
								<p-tabpanel value="0">
									<app-mailbox-form [form]="mailboxForm" />
								</p-tabpanel>

								<p-tabpanel value="1">
									<app-inbound-form [form]="inboundForm"/>
								</p-tabpanel>

								<p-tabpanel value="2">
									<app-outbound-form [form]="outboundForm"/>
								</p-tabpanel>
							</p-tabpanels>
						</p-tabs>

						<div class="mt-3 flex justify-content-end">
							<p-button
								label="Salva"
								[disabled]="mailboxForm.invalid || inboundForm.invalid || outboundForm.invalid"
								(onClick)="save()"/>
						</div>
					}

					@case ('EDIT_MAILBOX') {
						<div class="p-3">
							<p>Questa mailbox non ha configurazione</p>

							<p-button
								label="Configura"
								(onClick)="facade.startConfigWizard()"
							/>
						</div>
					}

					@case ('CONFIG_WIZARD') {
						@let step = store.step();

						<p-stepper [value]="MAILBOX_STEPS[step]" [linear]="true">
							<p-step-item [value]="MAILBOX_STEPS['INBOUND']">
								<p-step>Inbound</p-step>
								<p-step-panel>
									<ng-template #content>
										<app-inbound-step [form]="inboundForm"/>
									</ng-template>
								</p-step-panel>
							</p-step-item>

							<p-step-item [value]="MAILBOX_STEPS['OUTBOUND']">
								<p-step>Outbound</p-step>
								<p-step-panel>
									<ng-template #content>
										<app-outbound-step [form]="outboundForm"/>
									</ng-template>
								</p-step-panel>
							</p-step-item>

							<p-step-item [value]="MAILBOX_STEPS['REVIEW']">
								<p-step>Riepilogo</p-step>
								<p-step-panel>
									<ng-template #content>
										<app-review-step
											[inboundForm]="inboundForm"
											[outboundForm]="outboundForm"/>
									</ng-template>
								</p-step-panel>
							</p-step-item>
						</p-stepper>
					}

				}
			}
		</div>
	</div>
</div>
